import useAgency from 'features/Agency/useAgency';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import MaintainerChargeConnectorCardView from 'features/Maintainer/MaintainerChargeConnector/components/MaintainerChargeConnectorCardView';
import MaintainerChargeConnectorListView from 'features/Maintainer/MaintainerChargeConnector/components/MaintainerChargeConnectorListView';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ShowMoreText from 'react-show-more-text';

MaintainerChargePointDetailView.propTypes = {
  chargePointId: PropTypes.string,
};

function MaintainerChargePointDetailView(props) {
  // MARK: ---- PROPERTIES ----
  const { user, permissionList } = useSelector((state) => state.auth);
  const router = useRouter();
  const { operatorList } = useAgency();
  const { chargePointId } = props;
  const [chargePointDetail, setChargePointDetail] = useState(null);
  useEffect(() => {
    MaintainerHelper.API.requestGetChargePointDetail(chargePointId).then((chargePoint) => {
      setChargePointDetail(chargePoint);
    });
  }, [chargePointId]);
  const [chargePricing, setChargePricing] = useState(null);
  useEffect(() => {
    const pricingId = chargePointDetail?.pricing?.pricingId;
    if (pricingId) {
      ChargeHelper.API.requestGetChargePricingDetail(pricingId).then((pricing) => {
        setChargePricing(pricing);
      });
    }
  }, [chargePointDetail]);
  const [filterChargeTransaction, setFilterChargeTransaction] = useState({
    pointId: chargePointId,
  });

  // MARK: ---- METHODS ----

  return (
    <div>
      {/* mat ket noi tru sac */}
      {chargePointDetail?.status === 'DISCONNECTED' && (
        <div className="px-4 mt-4">
          {UIHelper.buildAlert(
            <i className="fa-duotone fa-circle-info fa-2x" style={{ color: AppColors.danger }} />,
            'Mất kết nối trụ sạc',
            'Trong thời gian mất kết nối các chức năng điều khiển trụ sạc sẽ bị vô hiệu hóa',
            AppColors.danger,
            'rgba(255, 246, 246, 1)'
          )}
        </div>
      )}

      {/* thong tin tru sac */}
      <div className="row p-0 m-0 px-2 mt-4">
        <div className="col-lg-12 mb-4 px-2">
          {UIHelper.buildCard(
            <div>
              {/* tieu de */}
              <div className="d-flex align-items-center justify-content-between px-4 py-3">
                <div className="flex-fill">
                  <div className="d-flex align-items-center gap-3">
                    {/* avatar */}
                    <div className="">
                      {UIHelper.buildAvatar(
                        chargePointDetail?.image
                          ? Utils.getFullUrl(chargePointDetail?.image)
                          : null,
                        44,
                        AppResource.images.chargeConnectorTypes.imgChargePointDefault
                      )}
                    </div>
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center gap-2">
                        <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                          {chargePointDetail?.pointCode?.toUpperCase()}
                        </span>
                        <KTLabel
                          text={ChargeHelper.Utils.getChargePointStatusName(
                            chargePointDetail?.status
                          )}
                          isInline={true}
                          size={KTLabelSize.medium}
                          additionalClassName={`label-light-${ChargeHelper.Utils.getChargePointStatusColor(
                            chargePointDetail?.status
                          )}`}
                        />
                      </div>
                      <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                        Địa chỉ:{' '}
                        <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                          {ChargeHelper.Utils.getChargeStationFullAddress(
                            chargePointDetail?.chargeStation
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row m-0 p-0 px-2">
                {/* thong tin tru sac */}
                <div className="col-lg-4 m-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildSectionTitle('Thông tin trụ sạc')}
                    {UIHelper.buildSectionCard(
                      <div>
                        {/* {UIHelper.buildCardCellItem('Mã trụ', chargePointDetail?.pointCode)} */}
                        {UIHelper.buildCardCellItem(
                          'Loại phương tiện',
                          chargePointDetail?.chargeModel?.vehicleType
                            ? ChargeHelper.Data.vehicleTypeOptions.find(
                              (item) => item.value === chargePointDetail?.chargeModel?.vehicleType
                            )?.name
                            : ''
                        )}
                        {UIHelper.buildCardCellItem(
                          'Trạm sạc',
                          chargePointDetail?.chargeStation?.name,
                          () => { }
                        )}
                        {UIHelper.buildCardCellItem(
                          'Nhà điều hành',
                          _.find(
                            operatorList,
                            (item) => item.operatorId === chargePointDetail?.operatorId
                          )?.name
                        )}
                        {/* {UIHelper.buildCardCellItem(
                          'Số điện thoại',
                          chargePointDetail?.phoneNumber
                        )} */}
                        {UIHelper.buildCardCellItem('Loại trụ sạc', chargePointDetail?.type)}
                        {UIHelper.buildCardCellItem(
                          'Dòng trụ sạc',
                          chargePointDetail?.chargeModel?.name,
                          () => { }
                        )}
                        {UIHelper.buildCardCellItem(
                          'Công suất tối đa',
                          chargePointDetail?.chargeModel?.power
                            ? _.toNumber(chargePointDetail?.chargeModel?.power) / 1000 + 'kW'
                            : ''
                        )}
                        {UIHelper.buildCardCellItem(
                          'Điện áp',
                          chargePointDetail?.chargeModel?.voltage
                            ? chargePointDetail?.chargeModel?.voltage + 'V'
                            : ''
                        )}
                        {/* {UIHelper.buildCardCellItem(
                          'Dòng điện tối đa',
                          chargePointDetail?.maxAmpere ? chargePointDetail?.maxAmpere + 'A' : ''
                        )} */}
                        {UIHelper.buildCardCellItem(
                          'Dòng điện tối đa',
                          !_.isNull(chargePointDetail?.maxAmpere)
                            ? chargePointDetail?.maxAmpere + 'A'
                            : ''
                        )}
                        {UIHelper.buildCardCellItem(
                          'Số Serial',
                          chargePointDetail?.serialNumber,
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* thong tin ket noi */}
                <div className="col-lg-4 m-0 px-2 mb-4">
                  <div>
                    {UIHelper.buildSectionTitle('Thông tin kết nối')}
                    {UIHelper.buildSectionCard(
                      <div>
                        {UIHelper.buildCardCellItem('CPID', chargePointDetail?.ocppId)}
                        {UIHelper.buildCardCellItem('Giao thức', chargePointDetail?.protocol)}
                        {UIHelper.buildCardCellItem('Địa chỉ IP', chargePointDetail?.ipAddress)}
                        {UIHelper.buildCardCellItem('IMSI', chargePointDetail?.imsi)}
                        {UIHelper.buildCardCellItem(
                          'Phiên bản Firmware',
                          chargePointDetail?.firmwareVersion,
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>

                  <div className='mt-4'>
                    {UIHelper.buildSectionTitle('Lịch bảo trì định kỳ')}
                    {UIHelper.buildSectionCard(
                      <div>
                        {UIHelper.buildCardCellItem('Ngày bắt đầu', '')}
                        {UIHelper.buildCardCellItem(
                          'Chu kỳ',
                          '',
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* gia sac dien */}
                <div className="col-lg-4 m-0 px-2 mb-4">
                  <div className=''>
                    {UIHelper.buildSectionTitle('Thông tin SIM')}
                    {UIHelper.buildSectionCard(
                      <div>
                        {UIHelper.buildCardCellItem('Số điện thoại', chargePointDetail?.phoneNumber)}
                        {UIHelper.buildCardCellItem('Số serial SIM', chargePointDetail?.iccid)}
                        {UIHelper.buildCardCellItem('Nhà mạng', chargePointDetail?.networkOperator)}
                        {UIHelper.buildCardCellItem('Gói cước', chargePointDetail?.dataPackage)}
                        {UIHelper.buildCardCellItem(
                          'HSD gói cước',
                          Utils.formatDateTimeToString(chargePointDetail?.dataPackageExpire, 'DD/MM/YYYY'),
                          null,
                          false
                        )}
                      </div>
                    )}
                  </div>

                  {/* mo ta */}
                  <div className="mt-4">
                    {UIHelper.buildSectionTitle('Mô tả lịch bảo trì')}
                    {UIHelper.buildSectionCard(
                      <div
                        className="px-3 py-2"
                        style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}
                      >
                        <ShowMoreText
                          lines={3}
                          more="Xem thêm"
                          less="Thu gọn"
                          className=""
                          anchorClass="text-success font-size-normal font-weight-bolder cursor-pointer hover-opacity-60"
                          onClick={() => { }}
                          expanded={false}
                          truncatedEndingComponent={'... '}
                        >
                        </ShowMoreText>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>,
            true,
            false,
            true,
            false,
            chargePointDetail?.connected === 0 ? AppColors.danger : AppColors.gray[300]
          )}
        </div>
      </div>

      {/* thong tin voi sac */}
      <div className="row p-0 m-0 px-0">
        <div className="col-lg-12 mb-4 px-0">
          {chargePointDetail?.chargeModel?.vehicleType === ChargeConstants.VehicleType.CAR ? (
            <div className="px-4">
              {UIHelper.buildCard(
                <div>
                  {UIHelper.buildCardHeader('Thông tin súng sạc', false, null, true)}
                  <div className="row p-0 m-0 px-2">
                    {chargePointDetail?.chargeConnectors?.length > 0 ? (
                      chargePointDetail?.chargeConnectors?.map((connector) => (
                        <div className="col-xl-6 mb-4 px-2" key={connector.connectorId}>
                          <MaintainerChargeConnectorCardView
                            chargePointDetail={chargePointDetail}
                            chargeConnectorDetail={connector}
                            onRefresh={() => {
                              ChargeHelper.API.requestGetChargePointDetail(chargePointId).then(
                                (chargePoint) => {
                                  setChargePointDetail(chargePoint);
                                  setFilterChargeTransaction({ ...filterChargeTransaction });
                                }
                              );
                            }}
                          />
                        </div>
                      ))
                    ) : (
                      <div className="">
                        {UIHelper.buildEmptyNoData('Trụ sạc này không chứa súng sạc nào.')}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <MaintainerChargeConnectorListView
              chargePointDetail={chargePointDetail}
              items={chargePointDetail?.chargeConnectors}
              onRefresh={() => {
                ChargeHelper.API.requestGetChargePointDetail(chargePointId).then((chargePoint) => {
                  setChargePointDetail(chargePoint);
                  setFilterChargeTransaction({ ...filterChargeTransaction });
                });
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MaintainerChargePointDetailView;
